import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "docs-wrapper q-pa-md" }
const _hoisted_2 = { class: "segment-toggle q-mb-md" }
const _hoisted_3 = {
  key: 0,
  class: "q-mb-lg"
}
const _hoisted_4 = { class: "row items-center justify-end q-gutter-sm" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-center q-pa-xl"
}
const _hoisted_6 = {
  key: 1,
  class: "text-grey text-body2"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "doc-date-label text-caption text-grey q-mb-xs" }
const _hoisted_10 = { class: "doc-title" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_13 = { class: "visit-header q-mb-sm" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "doc-date-label text-caption text-grey q-mb-xs" }
const _hoisted_16 = { class: "doc-title" }
const _hoisted_17 = {
  key: 4,
  class: "text-grey text-body2"
}

export type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  tg: string;
};

export type GroupedDocuments = {
  header: string;
  documents: UserDocument[];
};

type Category = 'researches' | 'conclusions' | 'directions' | 'others';


import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import {
  ref,
  computed,
  onMounted,
  watch,
  PropType,
} from 'vue';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '~store/index';

const __default__ = { name: 'PatientDocuments' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  category: String as PropType<string>,
},
  setup(__props) {

const props = __props;

const $q = useQuasar();

const ecoStore = useEcoHospitalStore();

const documents = ref<UserDocument[]>([]);
const loading = ref(false);

const MIN_DATE = new Date(2019, 0, 1);
const TODAY = new Date();

const RESEARCH_DOC_TYPES = new Set([
  85, 84, 28, 27, 116, 172, 101, 102, 122, 124, 123, 100, 36, 98, 103, 187, 99,
]);
const CONCLUSION_DOC_TYPES = new Set([
  44, 30, 192, 153, 202,
]);

const viewByVisits = ref(false);
const selectedCategory = ref('directions');

const datePopup = ref();

const goToMain = () => {
  router.push({
    name: 'HealthPageFull',
  });
};

onMounted(async () => {
  try {
    loading.value = true;
    documents.value = ecoStore.documents as UserDocument[];
    console.log(props.category);
    if (props.category === 'consultations') {
      viewByVisits.value = true;
    } else {
      selectedCategory.value = props.category ?? 'directions';
    }
  } catch (error) {
    console.error('Ошибка при загрузке документов:', error);
  } finally {
    loading.value = false;
  }
});

const categoryOptions = [
  { label: 'Направления', value: 'directions' },
  { label: 'Справки и заключения', value: 'conclusions' },
  { label: 'Протоколы исследований', value: 'researches' },
  { label: 'Остальные документы', value: 'others' },
];

const periodFrom = ref('');

const rememberRangeStart = (date: { day: number, month: number, year: number }) => {
  const dd = String(date.day).padStart(2, '0');
  const mm = String(date.month).padStart(2, '0');
  const yyyy = String(date.year);

  periodFrom.value = `${dd}.${mm}.${yyyy}`;
};

const setPeriod = () => {
  if (!periodFrom.value) {
    $q.notify({
      message: 'Укажите начало периода',
      color: 'warning',
      textColor: 'dark',
      icon: 'today',
    });
    return;
  }
  dateRange.value = {
    from: periodFrom.value,
    to: formatDate(TODAY),
  };
  closePopup();
};

const handleRangeUpdate = (val: { from?: string; to?: string } | string) => {
  if (!val) return;

  if (typeof val === 'string') {
    dateRange.value = {
      from: val,
      to: val,
    };
    return;
  }

  if (val.from && !val.to) {
    dateRange.value = {
      from: val.from,
      to: val.from,
    };
  } else {
    dateRange.value = val as { from: string; to: string };
  }
};

const formatDate = (date: Date) => {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const parseDate = (str: string): Date | null => {
  const [d, m, y] = str.split('.').map(Number);
  if (!d || !m || !y) return null;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};
const dateRange = ref<{ from: string; to: string } | null>({
  from: '01.01.2024',
  to: formatDate(TODAY),
});

const periodText = ref(
  `${dateRange.value?.from} — ${dateRange.value?.to}`,
);

const errorMessage = ref('');

const dateRangeOptions = (date: string) => {
  const [y, m, d] = date.split('/').map(Number);
  const dt = new Date(y, m - 1, d);

  return dt >= MIN_DATE && dt <= TODAY;
};

watch(dateRange, (val: { to: string, from: string } | null) => {
  if (!val?.from || !val?.to) return;

  const from = parseDate(val.from);
  const to = parseDate(val.to);

  if (!from || !to) return;

  if (from < MIN_DATE || to > TODAY) {
    errorMessage.value = 'Период должен быть с 01.01.2019 по сегодняшний день';
    return;
  }

  errorMessage.value = '';
  periodText.value = `${val.from} — ${val.to}`;
});

const closePopup = () => {
  datePopup.value?.hide();
};

const getDocumentCategory = (doc: { doc_type: number; is_napravlenie: number }): Category => {
  if (doc.is_napravlenie === 1) return 'directions';
  if (CONCLUSION_DOC_TYPES.has(doc.doc_type)) return 'conclusions';
  if (RESEARCH_DOC_TYPES.has(doc.doc_type)) return 'researches';
  return 'others';
};

const categoryFiltered = computed(() => {
  if (!documents.value.length) return [];

  return documents.value.filter((doc) => {
    if (!selectedCategory.value) return true;

    return getDocumentCategory(doc) === selectedCategory.value;
  });
});

const filteredByCategoryAndPeriod = computed(() => {
  if (!documents.value.length) return [];

  let from = new Date(2024, 0, 1);
  let to = new Date(2099, 11, 31);

  if (dateRange.value?.from && dateRange.value?.to) {
    const parsedFrom = parseDate(dateRange.value.from);
    const parsedTo = parseDate(dateRange.value.to);

    if (parsedFrom && parsedTo) {
      from = parsedFrom;
      to = parsedTo;
    }
  }

  return categoryFiltered.value
    .filter((doc) => {
      const d = parseDate(doc.date_doc);
      if (!d) return false;
      return d >= from && d <= to;
    })
    .sort(
      (a, b) => parseDate(b.date_doc)!.getTime()
        - parseDate(a.date_doc)!.getTime(),
    );
});

const parseInput = () => {
  const parts = periodText.value.split('—').map((s) => s.trim());
  if (parts.length !== 2) return;

  const from = parseDate(parts[0]);
  const to = parseDate(parts[1]);

  if (!from || !to) {
    errorMessage.value = 'Некорректный формат даты';
    return;
  }

  if (from < MIN_DATE || to > TODAY) {
    errorMessage.value = 'Доступный для выбора период с 01.01.2019 по сегодняшний день';
    return;
  }

  errorMessage.value = '';
  dateRange.value = {
    from: formatDate(from),
    to: formatDate(to),
  };
};

const NOT_STARTED_KEY = '__not_started__';

const groupedByVisit = computed(() => {
  const map = new Map<string, UserDocument[]>();

  documents.value.forEach((doc) => {
    const key = doc.datebegin ?? NOT_STARTED_KEY;

    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(doc);
  });

  const groups = Array.from(map.entries())
    .map(([date, docs]) => ({
      date,
      label: date === NOT_STARTED_KEY ? 'Без даты' : `Визит ${date}`,
      docs,
    }))
    .sort((a, b) => {
      if (a.date === NOT_STARTED_KEY) return -1;
      if (b.date === NOT_STARTED_KEY) return 1;

      const da = parseDate(a.date);
      const db = parseDate(b.date);

      if (da && db) return db.getTime() - da.getTime();

      if (db) return 1;
      if (da) return -1;

      return 0;
    });

  return groups;
});

const openInNewTab = async (doc: UserDocument) => {
  const path = await ecoStore.getFilePath(doc.id_document);
  if (path[0].hash) {
    window.open(`https://host2.medsafe.tech/${path[0].hash}`, '_tab');
  } else {
    useMainStore().showMessage('Извините, не смогли найти документ.');
  }
};

const download = async (doc: UserDocument) => {
  const path = await ecoStore.getFilePath(doc.id_document);
  const fileUrl = `https://host2.medsafe.tech/${path[0].hash}`;

  const response = await fetch(fileUrl);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = doc.doc_name;
  link.click();

  URL.revokeObjectURL(blobUrl);
};

return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createVNode(_component_q_breadcrumbs, {
        "active-color": "blue-10",
        "separator-color": "blue-10",
        class: "text-blue-grey-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_breadcrumbs_el, {
            class: "cursor-pointer",
            label: "Главная",
            icon: "home",
            onClick: goToMain
          }),
          _createVNode(_component_q_breadcrumbs_el, {
            label: "Документы",
            icon: "library_books"
          })
        ]),
        _: 1
      }),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-h5 text-weight-bold q-mb-xs" }, " Медицинские документы ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(['segment-btn', !viewByVisits.value ? 'segment-btn--active' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (viewByVisits.value = false))
        }, [
          _createVNode(_component_q_icon, {
            name: "filter_list",
            size: "16px",
            class: "q-mr-xs"
          }),
          _cache[7] || (_cache[7] = _createTextVNode(" По категориям "))
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(['segment-btn', viewByVisits.value ? 'segment-btn--active' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (viewByVisits.value = true))
        }, [
          _createVNode(_component_q_icon, {
            name: "date_range",
            size: "16px",
            class: "q-mr-xs"
          }),
          _cache[8] || (_cache[8] = _createTextVNode(" По визитам "))
        ], 2)
      ]),
      (!viewByVisits.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "filter-label q-mb-xs" }, "Выберите категорию", -1)),
            _createVNode(_component_q_select, {
              modelValue: selectedCategory.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCategory).value = $event)),
              options: categoryOptions,
              outlined: "",
              behavior: "menu",
              dense: "",
              "emit-value": "",
              "map-options": "",
              class: "q-mb-md filter-select"
            }, null, 8, ["modelValue"]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "filter-label q-mb-xs" }, "Период", -1)),
            _createVNode(_component_q_input, {
              modelValue: periodText.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((periodText).value = $event)),
              outlined: "",
              dense: "",
              mask: "##.##.#### — ##.##.####",
              "fill-mask": "",
              error: !!errorMessage.value,
              "error-message": errorMessage.value,
              onBlur: parseInput,
              class: "filter-input"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  color: "primary",
                  class: "cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      ref_key: "datePopup",
                      ref: datePopup
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: dateRange.value,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((dateRange).value = $event)),
                            handleRangeUpdate
                          ],
                          range: "",
                          mask: "DD.MM.YYYY",
                          color: "blue-10",
                          "text-color": "white",
                          subtitle: "Задайте период",
                          options: dateRangeOptions,
                          onRangeStart: rememberRangeStart,
                          onRangeEnd: closePopup
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_q_btn, {
                                label: `До сегодня (${formatDate(_unref(TODAY))})`,
                                onClick: _withModifiers(setPeriod, ["stop"]),
                                color: "primary",
                                flat: ""
                              }, null, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "error", "error-message"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_q_spinner, {
            size: "40px",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && documents.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Документы отсутствуют "))
      : _createCommentVNode("", true),
    (!viewByVisits.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredByCategoryAndPeriod.value, (doc) => {
            return (_openBlock(), _createElementBlock("div", {
              key: doc.id_document,
              class: "doc-card q-mb-sm",
              onClick: ($event: any) => (openInNewTab(doc))
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(doc.date_doc), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(doc.doc_name), 1),
              _createElementVNode("div", {
                class: "doc-actions",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "more_vert"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, { style: {"min-width":"140px"} }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              onClick: ($event: any) => (download(doc))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode("Скачать")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ])
            ], 8, _hoisted_8))
          }), 128))
        ]))
      : (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (groupedByVisit.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Документы по визитам отсутствуют "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByVisit.value, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.date,
                class: "visit-group q-mb-lg"
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(group.label), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.docs, (doc) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: doc.id_document,
                    class: "doc-card q-mb-sm",
                    onClick: ($event: any) => (openInNewTab(doc))
                  }, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(doc.date_doc), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(doc.doc_name), 1),
                    _createElementVNode("div", {
                      class: "doc-actions",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        round: "",
                        dense: "",
                        icon: "more_vert"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, { style: {"min-width":"140px"} }, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    onClick: ($event: any) => (download(doc))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { class: "text-accent" }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createTextVNode("Скачать")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ], 8, _hoisted_14))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    (!loading.value && filteredByCategoryAndPeriod.value.length === 0 && !viewByVisits.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Документы по категории за выбранный период отсутствуют "))
      : _createCommentVNode("", true)
  ]))
}
}

})